import React, {memo} from 'react';

import * as S from './ErrorBox.styles';

const ErrorBoxComp = () => {
  return (
    <S.Wrapper>
      <S.WarningIcon name="warning" />
      Something went wrong with rendering this information.
    </S.Wrapper>
  );
};

export const ErrorBox = memo(ErrorBoxComp);
